"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireWildcard(require("react"));

var _FlexTabContainer = _interopRequireDefault(require("../../FlexTabContainer"));

var _Accordion = _interopRequireDefault(require("../../Accordion"));

var _BenefitScenarios = _interopRequireDefault(require("../BenefitScenarios"));

var _utils = require("../../utils");

var _Title = _interopRequireDefault(require("../../Title"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/*
 * @Author: syd
 * @Date: 2021-02-04 04:24:59
 * @Last Modified by: syd
 * @Last Modified time: 2021-04-07 17:46:13
 */
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var TabPane = _FlexTabContainer["default"].TabPane;
var Scenarios = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var icon = props.icon,
      banner = props.banner,
      sharp = props.sharp,
      radius = props.radius,
      style = props.style,
      source = props.source,
      flexTitle = props.flexTitle,
      _a = props.imageLocation,
      imageLocation = _a === void 0 ? false : _a,
      configuration = props.configuration,
      className = props.className,
      onClick = props.onClick,
      restProps = __rest(props, ["icon", "banner", "sharp", "radius", "style", "source", "flexTitle", "imageLocation", "configuration", "className", "onClick"]); //判断是否使用的样式类型 -pc or mobile


  var _b = (0, _react.useState)(true),
      currentClass = _b[0],
      setCurrentClass = _b[1];

  (0, _react.useEffect)(function () {
    (0, _utils.windowAddEventListener)(setCurrentClass);
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", __assign({
    ref: ref
  }, restProps, {
    className: 'flex-default-scenarios-container',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-default-scenarios-container-children'
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle
  }), currentClass ? /*#__PURE__*/_react["default"].createElement(_FlexTabContainer["default"], null, configuration ? configuration.map(function (item, i) {
    var _a = item,
        title = _a.title,
        key = _a.key,
        content = _a.content,
        imageSrc = _a.imageSrc,
        tabTitle = _a.tabTitle,
        filedVideoBg = _a.filedVideoBg,
        filedVideoList = _a.filedVideoList;
    return /*#__PURE__*/_react["default"].createElement(TabPane, {
      key: i,
      tabIndex: key,
      title: tabTitle
    }, /*#__PURE__*/_react["default"].createElement("section", {
      className: 'ant-tabs-content-holder__section',
      style: {
        marginTop: '24px'
      }
    }, /*#__PURE__*/_react["default"].createElement(_BenefitScenarios["default"], {
      article: content,
      title: title,
      imageSrc: imageSrc,
      filedVideoBg: filedVideoBg,
      filedVideoList: filedVideoList,
      imageLocation: true,
      record: item
    })));
  }) : null) : /*#__PURE__*/_react["default"].createElement(_Accordion["default"], {
    configuration: configuration
  })));
});
Scenarios.displayName = 'TCIScenarios';
var _default = Scenarios;
exports["default"] = _default;